//import './login.css';
import MenuLateral from "../MenuLateral/menulateral";
import TabelaRelatorioIntencaoVenda from "./tabela";


function Listagem(){    
    
    return (
        <div class="container-fluid">
            <div class="row">
                <MenuLateral menu="relIntencaoVenda" admin={true}/>
                <div class="col-12 col-lg-2 mobile-hide invisible"></div>            
                <div id="conteudo" class="col-12 col-lg-10">
                    <TabelaRelatorioIntencaoVenda />
                </div>           
            </div>
        </div>
   
    )
}

export default Listagem;

